export default {"src":"/_next/static/media/mastercard-icon.44bcc7b3.svg","height":45,"width":70,"blurWidth":0,"blurHeight":0};